"use strict";exports.__esModule = true;exports.themeTokens5_4 = void 0;var themeTokens5_4 = exports.themeTokens5_4 = {
  clearCrossIconWidthSmall: '24px',
  clearCrossIconWidthMedium: '30px',
  clearCrossIconWidthLarge: '36px',
  clearCrossIconAlign: 'flex-start',
  textareaMargin: '0px', // обнуление вертикального браузерного margin в firefox
  textareaVerticalAlign: 'top'
};